var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tagType)?_c(_vm.tag,{tag:"component",style:({
    color: 'white',
    backgroundColor: _vm.tagType.color,
    fontSize: '0.625rem',
    fontWeight: 'bold',
    textAlign: 'center'
  })},[_vm._v(" "+_vm._s(_vm.tagType.label)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }